<template>
  <Modal
    :title="data.title || $t('global.ticket')"
    @close="close"
    @confirm="confirm"
    :hide-footer="true"
    size="large"
  >
    <template #body>
      <div v-if="!ticketOptions">
        <LoadingState />
      </div>
      <ContactSupportForm
        v-else-if="ticketOptions"
        :department-id="departmentId"
        :reply="data.reply"
        :service-id="data.serviceId"
        :subject="data.subject"
        :ticket-options="ticketOptions"
        :support="data.support"
        v-on="$listeners"
      />
      <div v-else>
        <ErrorState />
      </div>
    </template>
  </Modal>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import ContactSupportForm from "@/components/smart/forms/ContactSupportForm";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "ContactSupport",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ContactSupportForm,
    ErrorState,
    LoadingState,
    Modal,
  },
  setup(props, { emit }) {
    const ticketOptions = computed(() => store.getters["tickets/getTicketOptions"]);
    const departmentId = computed(() => {
      const department = props.data.department;
      if (department) {
        return ticketOptions.value?.departments?.find((item) => item.identity === department)?.id;
      }
      return null;
    });

    onMounted(() => {
      if (!store.getters["tickets/getTicketOptions"]) {
        store.dispatch("tickets/ticketOptions");
      }
    });

    const close = () => emit("close");
    const confirm = () => emit("confirm");

    return {
      close,
      confirm,
      departmentId,
      ticketOptions,
    };
  },
};
</script>
